import { buildURL, urls } from '../../../helpers/urls';
import { patch } from '../../../helpers/fetch';

// eslint-disable-next-line import/prefer-default-export
export const updateEventOverlays = (event) => {
  const url = buildURL(urls.events.root, 'overlays');
  return patch(url, event);
};
